<template>
	<div
		class="camera-wrapper"
		:class="{'camera-wrapper--active': active}"
	>
		<div class="icon" v-html="iconSrc"/>
		<h4 class="camera-name">{{ name }}</h4>
	</div>
</template>

<script>
export default {
	name: 'Camera',
	props: {
		iconSrc: {
			type: String,
			required: true,
		},
		name: {
			type: String,
			required: true,
		},
		active: {
			type: Boolean,
			default: false,
		},
	},
};
</script>

<style lang="sass" scoped>
.camera-wrapper
	box-sizing: border-box
	width: 114px
	height: 114px
	color: #000000

	display: flex
	flex-direction: column
	justify-content: center
	align-items: center

	cursor: pointer

	transition: color 0.2s

	@media (max-width: 650px)
		width: 70px
		height: 70px

.camera-wrapper--active
	color: #ffffff
	cursor: auto

.icon
	margin: auto

	@media (max-width: 650px)
		position: absolute
		transform: scale(0.55) translateY(-25%)

.camera-name
	margin: auto auto 14px auto
	font-size: 18px

	@media (max-width: 650px)
		margin-bottom: 6px
		font-size: 14px



</style>
